module.exports = __webpack_public_path__ + "img/turbo_off.8275873f.png";